import { store } from "../Redux";
import { EVENT_SERVICE_BASE_URL } from "../config/endpoints";
import { EventTypes } from "../data/eventTypes";
import { routesEventMap } from "../routes/routesEventMap";
import { getOS } from "../utils/browserDetails";
import { getAuthTokenFromLs, getBrowserDetails, getNetworkType, getPhoneNumberFromLs } from "../utils/commonUtils";
import packageJson from "../../package.json";
import { getSessionStorage } from "../utils/localStorage";
import { APPLITE, APPLITE_TEXT } from "../data/constants";

interface EventTrackerInitObj {
  eventBaseURL: string;
  channel: string;
  xCountry?: string;
  msisdn?: string | null;
  header?: { [key: string]: string | undefined };
}
export const eventTrackerInitialize = () => {
  try {
    if ((window as any)?.hasOwnProperty('eventTrackerInit')) {
      const eventTracker = (window as any)?.eventTrackerInit();
      if (eventTracker) {
        const initIObj: EventTrackerInitObj = {
          eventBaseURL: EVENT_SERVICE_BASE_URL,
          channel: APPLITE_TEXT,
          xCountry: process.env?.REACT_APP_IS_PROD !== "true" ? process.env.REACT_APP_X_COUNTRY : undefined,
          msisdn: getPhoneNumberFromLs(),
          header: process.env?.REACT_APP_IS_PROD !== "false" ? { OPCO: process.env.REACT_APP_OPCO } : {}
        }
        initIObj.header = {
          ...initIObj.header,
          clientName: APPLITE,
          Authorization: process.env.REACT_APP_EVENT_AUTH_TOKEN || ""
        }
        eventTracker?.initialize(initIObj);
      }
    }
  } catch (error) {
    console.log("Error initializing event tracker", error);
  }
}

export const sendPageViewEvent = () => {
  sendEvent({ eventType: EventTypes.PAGE_VIEW, action: `${routesEventMap[window?.location?.pathname]}_page_view` });
}

export const sendEvent = ({ eventType, ...rest }: SendEvent) => {
  try {
    const os = getOS();
    const browser = getBrowserDetails();
    if ((window as any)?.hasOwnProperty('eventTrackerInit')) {
      const eventTracker = (window as any)?.eventTrackerInit();
      if (eventTracker && store.getState().config?.launchConfig?.customEventMgmtConfig?.eventsEnabled) {
        const date = new Date();
        eventTracker.send({
          eventType: eventType,
          token: getAuthTokenFromLs(),
          timeStamp: date.toISOString(),
          msisdn: getPhoneNumberFromLs(),
          iso_country_code: process.env.REACT_APP_OPCO,
          sessionId: getSessionStorage("sessionId") || "",
          userDevice: {
            os: os.name,
            build_version_name: packageJson.version,
            browser: browser.name,
            browser_version: browser.version,
            connection_type: getNetworkType()
          },
          ...rest
        });
      }
    }
  } catch (error) {
    console.log("Error sending event", error);
  }
}

export interface SendEvent {
  eventType: string;
  [key: string]: string | number | boolean | object | null | undefined;
}